import { useIsMobile } from "../volleyball/context/mobileContext";
import NCAAFDesktopDashboard from "./screens/NCAAFDesktopDashboard";
import NCAAFMobileDashboard from "./screens/NCAAFMobileDashboard";

const NCAAFDashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <NCAAFMobileDashboard /> : <NCAAFDesktopDashboard />;
};

export default NCAAFDashboard;
